import axios from "axios";
import { useEffect, useState } from "react";
import { FORMS_CHANGED_EVENT } from "../services/formUploadService";

// Does the officer have any form to fill out (their own or the department's)?
// Used to decide whether a case offers "Fill Forms" at all. The answer is shared
// by everything on screen (so opening case after case asks only once) and is
// refreshed when forms are uploaded, deleted or finish processing.
let known: boolean | null = null;
let inflight: Promise<boolean> | null = null;

function lookup(force = false): Promise<boolean> {
  if (!force && known !== null) return Promise.resolve(known);
  if (!inflight) {
    inflight = axios
      .get("/api/forms/templates")
      .then((res) => (known = Array.isArray(res.data) && res.data.length > 0))
      // If we cannot tell, do not offer a button that may lead nowhere.
      .catch(() => (known = false))
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

// Tests only.
export const resetHasFormsForTests = () => {
  known = null;
  inflight = null;
};

export function useHasForms(): boolean {
  const [has, setHas] = useState<boolean>(known === true);

  useEffect(() => {
    let cancelled = false;
    const refresh = (force: boolean) => lookup(force).then((v) => !cancelled && setHas(v));
    void refresh(false);
    const onChange = () => void refresh(true);
    window.addEventListener(FORMS_CHANGED_EVENT, onChange);
    return () => {
      cancelled = true;
      window.removeEventListener(FORMS_CHANGED_EVENT, onChange);
    };
  }, []);

  return has;
}
